import React, { useEffect, useState } from "react";
import styles from "./Reservations.module.css";
import { db } from "../../firebase"; 
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

// --- SENDZEN CONFIGURATION ---
const SENDZEN_CONFIG = {
  API_KEY: "sz_sandbox_Muc_zaaXPDpzVFtWeragtVuUDHYZi1_fPsWBhggy7Kj3aA", // Replace with your actual key
  // API_KEY: "sz_sandbox_Muc_zaaXPDpzVFtWeragtVuUDHYZi1_fPsWBhggy7Kj3aA", // Replace with your actual key
  OWNER_PHONE: "918554872614",   // Owner's number
  SANDBOX_NUMBER: "15557814168" // SendZen Sandbox Number
};

const Reservations = ({ isPopup = false, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    date: "",
    guests: "",
    timings: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isPopup) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isPopup]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "guests") {
      const val = parseInt(value);
      if (val > 10) {
        alert("Max 10 people allowed");
        setFormData({ ...formData, [name]: "10" });
        return;
      }
    }

    setFormData({ ...formData, [name]: value });
  };

  // --- SENDZEN API HELPER ---
  const sendWhatsAppNotification = async (data) => {
    const url = "https://api.sendzen.io/v1/messages";

    const payload = {
      from: SENDZEN_CONFIG.SANDBOX_NUMBER,
      to: SENDZEN_CONFIG.OWNER_PHONE,
      type: "text",
      text: {
        body: `*New Table Reservation!* 🍽️\n\n` +
          `*Name:* ${data.fullName}\n` +
          `*Phone:* ${data.phone}\n` +
          `*Date:* ${data.date}\n` +
          `*Guests:* ${data.guests} People\n` +
          `*Time:* ${data.timings}\n\n` +
          `*Message:* ${data.message}`
      }
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${SENDZEN_CONFIG.API_KEY}`
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        console.log("Reservation WhatsApp Sent!");
      } else {
        const errorData = await response.json();
        console.error("SendZen Error:", errorData);
      }
    } catch (err) {
      console.error("WhatsApp Connection Error:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // 1. Save to Firestore
      await addDoc(collection(db, "reservations"), {
        ...formData,
        createdAt: serverTimestamp(),
      });

      // 2. Send WhatsApp Notification
      await sendWhatsAppNotification(formData);

      alert("Reservation successful!");
      
      if (isPopup) onClose();

      // Reset form
      setFormData({
        fullName: "", phone: "", email: "", date: "",
        guests: "", timings: "", message: ""
      });

    } catch (error) {
      console.error("Error adding document: ", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains(styles.popupWrapper)) {
      onClose && onClose();
    }
  };

  return (
    <section
      className={`${styles.wrapper} ${isPopup ? styles.popupWrapper : ""}`}
      onClick={isPopup ? handleOverlayClick : undefined}
    >
      <div className={`${styles.container} ${isPopup ? styles.popupContainer : ""}`}>
        {!isPopup && (
          <div className={styles.imageSection}>
            <img src="https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/AARMS%20Photography-1.jpg" alt="Restaurant" />
          </div>
        )}

        <div className={styles.formSection}>
          {isPopup && (
            <button className={styles.closeBtn} onClick={onClose}>×</button>
          )}

          <h2>RESERVE A TABLE</h2>

          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.row}>
              <div className={styles.inputGroup}>
                <input type="text" name="fullName" required value={formData.fullName} onChange={handleChange} />
                <label>Full Name</label>
              </div>

              <div className={styles.inputGroup}>
                <input type="text" name="phone" required value={formData.phone} onChange={handleChange} />
                <label>Phone No.</label>
              </div>
            </div>

            <div className={styles.row}>
              <div className={styles.inputGroup}>
                <input type="email" name="email" required value={formData.email} onChange={handleChange} />
                <label>Email</label>
              </div>

              <div className={styles.inputGroup}>
                <input
                  type="date"
                  name="date"
                  required
                  className={styles.dateInput}
                  value={formData.date}
                  onChange={handleChange}
                  onClick={(e) => e.target.showPicker()}
                />
                <label>Date</label>
              </div>
            </div>

            <div className={styles.row}>
              <div className={styles.inputGroup}>
                <input
                  type="number"
                  name="guests"
                  required
                  min="1"
                  value={formData.guests}
                  onChange={handleChange}
                />
                <label>No. of People</label>
              </div>

              <div className={styles.inputGroup}>
                <select name="timings" required value={formData.timings} onChange={handleChange}>
                  <option value="" disabled hidden></option>
                  <option value="7-8:30 PM">7:00 PM – 8:30 PM</option>
                  <option value="8:30-10 PM">8:30 PM – 10:00 PM</option>
                </select>
                <label>Timings</label>
              </div>
            </div>

            <div className={styles.inputGroup}>
              <textarea name="message" rows="4" required value={formData.message} onChange={handleChange}></textarea>
              <label>Message</label>
            </div>

            <button 
              type="submit" 
              disabled={loading}
              className={`${styles.button} ${isPopup ? styles.fullButton : ""}`}
            >
              {loading ? "Processing..." : "Reserve Table"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Reservations;